import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import { encryptToken } from "../../../Services/Encryption/EncryptionParams";

const ReportStageTable = (props) => {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );
  const ChangeStatusReportStageResult=useSelector((state)=>state.StartProgressReportReducer.ChangeStatusReportStage)
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "field",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "fieldName",
        keyValueName: "fieldNameId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicantName",
      ShowStatus: true,
      NmaeColumn: "اسم المتقدم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "foundationName",
      ShowStatus: true,
      NmaeColumn: "اسم المؤسسة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researchProjectTitleInArabic",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "researchProjectTitleInArabic",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "currentStageName",
      ShowStatus: true,
      NmaeColumn: "اسم المرحلة الحالية",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "reportStatusName",
      ShowStatus: true,
      NmaeColumn: "حالة التقرير",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "reportStatusName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    // {
    //   KeyName: "ratingRate",
    //   ShowStatus:
    //     props.flow === "57a734e4-a94e-4896-818d-6c7a5fa59275" ||
    //     props.flow === "f45e184a-c575-4e7c-8b29-80cc55790232" ||
    //     props.flow === "6517f500-de92-4313-a737-ca771cf2f2eb",
    //   NmaeColumn: "معدل التقييم",
    //   TotalNumber: true,
    //   DropdownFiltration: {
    //     keyTextName: "applicantTypeAr",
    //     keyValueName: "applicantTypeAr",
    //   },
    //   DropdownFiltrationStatus: true,
    //   GroupOfColumns: false,
    // },
    // {
    //   KeyName: "evaluationStatus",
    //   ShowStatus:
    //     props.flow === "57a734e4-a94e-4896-818d-6c7a5fa59275" ||
    //     props.flow === "f45e184a-c575-4e7c-8b29-80cc55790232" ||
    //     props.flow === "6517f500-de92-4313-a737-ca771cf2f2eb",
    //   NmaeColumn: "حالة التقييم",
    //   TotalNumber: true,
    //   DropdownFiltration: {
    //     keyTextName: "statusNameAr",
    //     keyValueName: "appStatusId",
    //   },
    //   DropdownFiltrationStatus: true,
    //   GroupOfColumns: false,
    // },
  ];
  console.log(arrayDataCheckBoks, "ssssssdwdwdddd");

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        console.log(objects.applicationInformationId,"ddddddddddfwefwf");
        
        let token = encryptToken(objects.applicationInformationId);
        window.open(
          `/SRFund/manager/MainResearcherInformainContainer/` + token,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      keyNameTarget: "aI_ApplicationInformationId",
      ShowStatus: true,
      InitialScreeningAssessment: true,

      // byStatusShowOrHide: true,
    },
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        console.log(objects.reportId,"sssssdwdwdwd");
        
        navigate(`/SRFund/report/ProgressReportPreparation/${objects.reportId}`);
        // navigate(`/SRFund/report/EmployeeTransfers/${objects.reportId}`);

          
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: true,
      InitialScreeningAssessment: true,
      // byStatusShowOrHide: true,

    },
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        console.log(objects.reportId,"sssssdwdwdwd");
        
        // navigate(`/SRFund/report/ProgressReportPreparation/${objects.reportId}`);
        navigate(`/SRFund/report/EmployeeTransfers/${objects.reportId}`);

          
      },
      content: "",
      className: "bi bi-sliders",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: true,
      InitialScreeningAssessment: true,
      // byStatusShowOrHide: true,

    },
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        navigate(`/SRFund/report/StagesTable/${objects.reportId}`);
      },
      content: "",
      className: "bi bi-table",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: true,
      // InitialScreeningAssessment: true,
      byStatusShowOrHide: true,

    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [props.roundActive, props.fields,ChangeStatusReportStageResult]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        // RequestsManagerValue={true}
        AllValueAction={true}
        uniqueValue={"taskId"}
        valueButtonAction={"taskId"}
        URL={`api/Report/GetAllReport`}
        UrlBody={{
          roundYearId: props.roundActive,
          fieldId: props.fields,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        uniqeKeyNameRedux={"tasksList"}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};

export default ReportStageTable;
